import React from 'react';

function Icon({ name, color = 'info', fontSize = '1rem', ...rest }) {
  return <i className={`${name} text-${color}`} style={{ fontSize }} {...rest} />;
}

export default Icon;
